<template>
  <div class="appointment-embed">
    <div v-if="loading" class="appointment-loader">
      <i class="pi pi-spin pi-spinner" />
      <span>Loading appointment booking…</span>
    </div>
    <iframe
      v-show="!loading"
      :src="iframeUrl"
      class="appointment-frame"
      frameborder="0"
      @load="loading = false"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import { useRoute } from 'vue-router'
import { getAppointmentBaseUrl } from '@/config'

const route = useRoute()
const session = JSON.parse(localStorage.getItem('UsersData') || '{}')

const HospitalId       = Number(session?.OrganizationId ?? 0)
const HospitalIdString = String(session?.HospitalCode ?? '')
const UserId           = Number(session?.UserId ?? 0)
const patientId        = ref<string>((route.query.PatientId as string) ?? '')

const loading = ref(true)

// Mirrors MoceroUI: appointment app is an external iframe, login (if any) happens inside the frame.
const iframeUrl = computed(() =>
  `${getAppointmentBaseUrl()}?PatientId=${patientId.value}&sourceType=0&HospitalId=${HospitalId}&HospitalIdString=${HospitalIdString}&UserId=${UserId}`
)
</script>

<style scoped lang="scss">
.appointment-embed {
  position: relative;
  width: 100%;
  height: calc(100vh - 120px);
}
.appointment-frame {
  width: 100%;
  height: 100%;
}
.appointment-loader {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  color: #6b7280;
  font-size: 0.9rem;

  .pi-spinner { font-size: 1.8rem; color: #126373; }
}
</style>
